import { FC } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import ApplicationStatus from 'portfolio3/features/proforientation/components/GenericApplicationCard/ApplicationStatus';
import { Attributes } from 'portfolio3/ui-kit';
import { mergeSx } from 'utils';

import * as styles from './styles';

interface IGenericApplicationCardProps {
  date: string;
  industry: string;
  name: string;
  place?: string;
  statusApplicationCode: number;
  bottomAddon?: React.ReactNode;
}

const GenericApplicationCard: FC<IGenericApplicationCardProps> = ({
  date,
  industry,
  name,
  place,
  statusApplicationCode,
  bottomAddon,
}) => {
  const attributes = [date, industry].filter(Boolean).map((value) => {
    return (
      <Typography variant="Paragraph MD/Regular" key={value}>
        {value}
      </Typography>
    );
  });

  const leftElement = (
    <Stack gap="8px">
      <Attributes attributes={attributes} />
      <Typography variant="Paragraph LG/Semi Bold">{name}</Typography>
      {place && <Typography variant="Paragraph MD/Regular">{place}</Typography>}
    </Stack>
  );

  const rightElement = (
    <ApplicationStatus
      statusApplicationCode={statusApplicationCode}
      sx={mergeSx(styles.rootRight, { alignSelf: 'flex-end' })}
    />
  );

  return (
    <Box className="generic-application-card" sx={styles.root}>
      <Box className="generic-application-card__main" sx={mergeSx(styles.rootMain, { flexDirection: 'row' })}>
        {leftElement}
        {rightElement}
      </Box>
      {bottomAddon}
    </Box>
  );
};

export default GenericApplicationCard;
